import detailMessage from './detailMessage';
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { confirmEmailChange } from "./api";
import ConfirmShell from "./components/ConfirmShell";
import { useLang } from "./LangContext";

type Status = "loading" | "ok" | "error";

interface OkData {
  e_mail: string;
}

interface PageState {
  status: Status;
  data?: OkData;
  message?: string;
}

export default function EmailChangeConfirmPage() {
  const { t } = useLang();
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<PageState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    confirmEmailChange(token!)
      .then((data: OkData) => {
        if (cancelled) return;
        setState({ status: "ok", data });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const detail = detailMessage(err, t.somethingWentWrong);
        setState({ status: "error", message: detail });
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <ConfirmShell>
      {state.status === "loading" && (
        <>
          <div className="confirm-spinner" aria-hidden="true" />
          <h2>{t.activatingEmail}</h2>
        </>
      )}
      {state.status === "ok" && (
        <>
          <div className="confirm-status-icon ok" aria-hidden="true">✓</div>
          <h2>{t.emailUpdatedTitle}</h2>
          <p>{t.emailUpdatedMessage(state.data!.e_mail)}</p>
          <p className="close-tab-hint">
            <Link to="/">{t.backToLogin}</Link>
          </p>
        </>
      )}
      {state.status === "error" && (
        <>
          <div className="confirm-status-icon error" aria-hidden="true">!</div>
          <h2>{t.somethingWentWrong}</h2>
          <p>{state.message}</p>
          <p className="close-tab-hint">{t.closeTab}</p>
        </>
      )}
    </ConfirmShell>
  );
}
